import { action, makeObservable, observable } from "mobx";

type AuthModalStep =
  | "LOGIN"
  | "SIGNUP"
  | "RESETPASSWORD"
  | "RESETPASSWORDCONFIRMATION";

class AuthStore {
  modalVisible = false;
  initialStep: AuthModalStep = "LOGIN";
  // Email typed elsewhere (Group unlock) and carried into the login form.
  prefilledEmail: string | null = null;
  pendingAction: (() => void) | null = null;

  constructor() {
    makeObservable(this, {
      modalVisible: observable,
      initialStep: observable,
      prefilledEmail: observable,
      setModalVisible: action,
      openModal: action,
    });
  }

  getModalIsVisible() {
    return this.modalVisible;
  }

  setModalVisible(value: boolean) {
    this.modalVisible = value;

    if (!value) {
      this.initialStep = "LOGIN";
      this.prefilledEmail = null;
    }
  }

  openModal(step: AuthModalStep = "LOGIN", options: { email?: string } = {}) {
    this.initialStep = step;
    this.prefilledEmail = options.email?.trim() || null;
    this.modalVisible = true;
  }

  getInitialStep() {
    return this.initialStep;
  }

  getPrefilledEmail() {
    return this.prefilledEmail;
  }

  setPendingAction(action: (() => void) | null) {
    this.pendingAction = action;
  }

  consumePendingAction() {
    const action = this.pendingAction;
    this.pendingAction = null;

    return action;
  }
}

const authStore = new AuthStore();

export default authStore;
